import { render, staticRenderFns } from "./ImageSliderModal.vue?vue&type=template&id=6c2ebdd6&scoped=true&"
import script from "./ImageSliderModal.vue?vue&type=script&lang=js&"
export * from "./ImageSliderModal.vue?vue&type=script&lang=js&"
import style0 from "./ImageSliderModal.vue?vue&type=style&index=0&id=6c2ebdd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2ebdd6",
  null
  
)

export default component.exports